import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';

export default function StartLLCSection() {
  const { t } = useTranslation();
  const isEs = i18n.language === 'es';

  const steps = [
    { icon: 'ri-building-4-line', label: t('home_no_llc_step_1'), num: '01' },
    { icon: 'ri-line-chart-line', label: t('home_no_llc_step_2'), num: '02' },
    { icon: 'ri-funds-line', label: t('home_no_llc_step_3'), num: '03' },
  ];

  return (
    <section className="py-20 px-6 lg:px-8 bg-[#2D1547] relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-80 h-80 bg-[#4F2D63]/30 rounded-full -translate-x-40 -translate-y-40 pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#4F2D63]/20 rounded-full translate-x-48 translate-y-48 pointer-events-none" />

      <div className="max-w-7xl mx-auto relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Left: Text */}
          <div>
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#4F2D63] border border-[#7B4A94] mb-5">
              <i className="ri-building-line text-[#DBB6EE] text-sm"></i>
              <span className="text-xs font-semibold text-[#DBB6EE] uppercase tracking-widest">
                {t('home_no_llc_eyebrow')}
              </span>
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
              {t('home_no_llc_title_1')}<br />
              <span className="text-[#DBB6EE]">{t('home_no_llc_title_2')}</span>
            </h2>

            <p className="text-base text-[#C4A7D8] leading-relaxed mb-8 max-w-lg">
              {t('home_no_llc_subtitle')}
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-4 mb-6">
              <Link
                to={isEs ? '/es/inicia-tu-llc' : '/start-your-llc'}
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-white text-[#2D1547] font-semibold text-sm hover:bg-[#F8F3FB] transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('home_no_llc_cta')}
              </Link>
              <div className="flex items-center gap-2 text-sm text-[#C4A7D8]">
                <i className="ri-shield-check-line text-[#A78BCA]"></i>
                <span>{t('home_no_llc_tag')}</span>
              </div>
            </div>

            <p className="text-xs text-[#9B7CB8] italic">{t('home_no_llc_compliance')}</p>
          </div>

          {/* Right: Steps visual */}
          <div className="space-y-4">
            {steps.map((step, idx) => (
              <div
                key={step.num}
                className="flex items-center gap-5 p-5 rounded-2xl bg-[#3E1F5C]/60 border border-[#5E3B72]/50 backdrop-blur-sm"
              >
                {/* Number */}
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-xl bg-[#4F2D63] border border-[#7B4A94]">
                  <span className="text-xs font-bold text-[#DBB6EE]">{step.num}</span>
                </div>

                {/* Icon + label */}
                <div className="flex items-center gap-3 flex-1">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#4F2D63]/60">
                    <i className={`${step.icon} text-[#DBB6EE] text-base`}></i>
                  </div>
                  <span className="text-sm font-semibold text-white">{step.label}</span>
                </div>

                {/* Arrow if not last */}
                {idx < steps.length - 1 && (
                  <div className="flex-shrink-0">
                    <i className="ri-check-line text-[#A78BCA] text-lg"></i>
                  </div>
                )}
                {idx === steps.length - 1 && (
                  <div className="flex-shrink-0">
                    <span className="text-xs font-semibold text-[#34D399] bg-[#34D399]/10 px-2.5 py-1 rounded-full whitespace-nowrap">Goal</span>
                  </div>
                )}
              </div>
            ))}

            {/* Timeline connector hint */}
            <div className="mt-5 pt-5 border-t border-[#5E3B72]/40">
              <div className="flex items-center gap-3">
                <div className="flex -space-x-2">
                  {['bg-[#DBB6EE]', 'bg-[#A78BCA]', 'bg-[#7B4A94]'].map((c, i) => (
                    <div key={i} className={`w-7 h-7 rounded-full ${c} border-2 border-[#2D1547]`} />
                  ))}
                </div>
                <p className="text-xs text-[#C4A7D8]">
                  {isEs ? 'Miles de emprendedores ya están en este camino' : 'Thousands of entrepreneurs already on this path'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
